var map = {
	"./2Lotus4-dator.jpg": 5149,
	"./2Lotus91.jpg": 7654,
	"./2Lotus93.jpg": 9956,
	"./2Lotus98.jpg": 9627,
	"./2Lotus992.jpg": 6998,
	"./blue-logo.png": 5479,
	"./compressjpeg.zip": 5132,
	"./drinks-dator.jpg": 1321,
	"./facebook.png": 7359,
	"./flower-logo.png": 6856,
	"./frida&cecilia.jpg": 8243,
	"./frida&cecilia2.jpg": 5129,
	"./frontImage.jpg": 5135,
	"./instagram.png": 9719,
	"./lokal/246c62a4-371c-4b8b-bb3f-67dd8b93f128.MP4": 6403,
	"./lokal/IMG_3708.JPG": 9960,
	"./lokal/rental1.JPG": 9123,
	"./lokal/rental2.JPG": 8196,
	"./lokal/rental3.JPG": 1217,
	"./lokal/rental4.JPG": 1810,
	"./lokal/rental5(filip).JPG": 6940,
	"./lokal/rental6(filip).JPG": 9613,
	"./lokal/rental7(filip).JPG": 2242,
	"./lokal/rental8(filip).JPG": 1139,
	"./mat/coldSandwich-dator.jpg": 5412,
	"./mat/compressjpeg.zip": 2581,
	"./mat/drinks-mobil.jpg": 193,
	"./mat/food-dator.jpg": 7149,
	"./mat/frukost1.jpg": 2721,
	"./mat/lunch-dator(FC).jpg": 5561,
	"./mat/lunch-dator(josefin).jpg": 1654,
	"./mat/plocktallrik.JPG": 3765,
	"./mat/snacks-dator.jpg": 1180,
	"./mat/warmSandwich-dator.jpg": 2537,
	"./startPage-dator.jpg": 6741,
	"./startPage-mobil.jpg": 4992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;